import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import {fetchHotoSites} from "../../../services/redux/maintenance/hoto/action";

const HotoSiteListing = ({
                       fetchHotoSites,
                       hotoSiteData,
                       getGOLiveFilterDropDown,
                       liveFilterDropDown,
                       match
                     }) => {
  const headers = [
    'Site Number',
    'Site Type',
    'Site Name',
    'City',
    'Assigned To',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [listType, setListType] = useState();
  const [team, setTeam] = useState();

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("mainSiteCont") &&
      localStorage.getItem("mainSiteCont")
    );
    if(installationCont){
      localStorage.setItem("mainGoLive", JSON.stringify(""));
      localStorage.setItem("mainSiteCont", 0);
    }

  }, []);

  useEffect(() => {
    if (match.params.listType) {
      setListType(match.params.listType);
      setTeam(match.params.team);
    }
  }, [])

  useEffect(() => {
    if (fetchHotoSites !== null)
      (async () => {
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("mainGoLive") &&
          localStorage.getItem("mainGoLive")
        );
        setIsLoading(true);
        if(getcontractFilter){
          await fetchHotoSites(match.params.team, match.params.listType, 1, getcontractFilter);
        }else{
          await fetchHotoSites(match.params.team, match.params.listType, 1);
        }
        setIsLoading(false);
      })();
  }, [fetchHotoSites]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("mainGoLive", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchHotoSites(match.params.team, match.params.listType, 1, filterData);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    const tableData = [
      'site_id',
      'site_no',
      'site_type',
      'client_name',
      'city_name',
      'assigned_to',
    ];
    if (hotoSiteData && hotoSiteData.resultSets) {
      const data = hotoSiteData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),

            listType == 2 ?
              team == 1 ?
                {
                  Action: [
                    {
                      name: "View Details",
                      link: `/dashboard/hoto/installation-approval/` + element.id,
                    }
                  ]
                }
              :
                {
                  Action: [
                    {
                      name: "View Details",
                      link: `/dashboard/hoto/maintenance-approval/` + element.id,
                    }
                  ]
                }
            : {
              Action: [
                {
                  name: "Assign to Engineer",
                  link: `/dashboard/hoto/change-assignee/` + match.params.team,
                }
              ]
            },

        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        newData && setListData(newData);
      }
      setPageCount(Math.ceil(hotoSiteData.total / hotoSiteData.per_page));
    }
  }, [hotoSiteData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchHotoSites(match.params.team, match.params.listType, val.selected + 1, filterData);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={(match.params.team == 1 && match.params.listType == 1) ? 'Hoto Installation Sites' : (match.params.team == 2 && match.params.listType == 1) ? 'Hoto Maintenance Sites' : (match.params.team == 1 && match.params.listType == 2) ? 'Hoto Installation Approval' : 'Hoto Maintenance Approval'}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        srNo={hotoSiteData?.from}
        onPageChange={onPageChange}
        detailList={hotoSiteData && hotoSiteData.resultSets}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={
          liveFilterDropDown?.site_type ? liveFilterDropDown : null
        }
        liveFilterDropDown
      />
    </Layout>
  );
};
export default HotoSiteListing;
